module.exports = __webpack_public_path__ + "static/img/4.1b2aa18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/4.png
// module id = sD9R
// module chunks = 0